import MainLayout from '@layouts/MainLayout';
import AccountLayout from '@layouts/AccountLayout';

import {useEffect, useState} from 'react';
import OrderItemCard from '@components/OrderComponents/OrderCard';
import Breadcrumb from '@components/Common/Breadcrumb';
import NavLink from '@components/Common/NavLink';
import {serverSideTranslations} from 'next-i18next/serverSideTranslations';
import NoOrder from '@components/OrderComponents/NoOrder';
import {useRequest} from '@hooks/use-request';
import ThreeDotsLoader from '../../content-loader/ThreeDotsLoader';
import OrderFilter from '@components/OrderComponents/OrderFilter';
import {useTranslation} from 'next-i18next';
import {useRouter} from 'next/router';
import {OrderInterface} from '@interfaces/order';
import {GetServerSidePropsContext} from 'next';
import {getServerSession} from 'next-auth/next';
import {authOptions} from '../api/auth/[...nextauth]';

export default function Orders() {
  const {t} = useTranslation('customer-orders');

  const router = useRouter();
  const {sendRequest} = useRequest();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<{
    rows: OrderInterface[];
  }>();
  const [status, setStatus] = useState<{value: string}>();
  const getCustomerOrders = async () => {
    setLoading(true);
    await sendRequest({
      url: `/customer/orders?status=${status?.value || ''}`,
      method: 'get',
      requiresAuth: true,
      onSuccess: response => {
        setLoading(false);
        setData(response.data);
      },
    });
  };
  useEffect(() => {
    getCustomerOrders().then(() => {});
  }, [status]);
  return (
    <MainLayout>
      <Breadcrumb classNames={'mt-2 mb-2 pb-0'}>
        <NavLink href={router.asPath}>{t<string>('navlinks.orders')}</NavLink>
      </Breadcrumb>
      <AccountLayout page={'orders'}>
        <div className="row">
          <div className="col-12">
            {loading ? (
              <ThreeDotsLoader />
            ) : (
              <div className="row ">
                <div className="col-12 mb-3">
                  <div className="row align-items-center">
                    <div className="col-sm-6">
                      <h3 className={'mb-0'}>
                        {t<string>('titles.my_orders')}
                      </h3>
                    </div>
                    <div className="col-6 d-flex justify-content-end">
                      <OrderFilter
                        value={status}
                        onSelect={val => setStatus(val)}
                      />
                    </div>
                  </div>
                </div>

                {!data?.rows || data.rows.length === 0 ? (
                  <NoOrder />
                ) : (
                  data.rows.map(row => {
                    return (
                      <div key={row.id} className="col-sm-6 col-md-4">
                        <OrderItemCard order={row} />
                      </div>
                    );
                  })
                )}
              </div>
            )}
          </div>
        </div>
      </AccountLayout>
    </MainLayout>
  );
}

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  const {locale} = ctx;
  const session = await getServerSession(ctx.req, ctx.res, authOptions);
  if (session?.user) {
    return {
      props: {
        ...(await serverSideTranslations(locale!, [
          'common',
          'customer-orders',
          'account-details',
        ])),
      },
    };
  }
  return {
    redirect: {
      destination: '/',
      permanent: false,
    },
  };
}
